import React, { useRef } from 'react';
import { useFormContext } from '../../components/FormContext';


const PhotoSection = () => {
  const { 
    formData, 
    formErrors, 
    modifiedFields,
    setFormErrors, 
    setFile,
    setModifiedFields
  } = useFormContext();
  const photoInputRef = useRef(null);
  
  const validateImageFile = (field, e) => {
    
    const file = e.target.files[0];
    setFile('photo', file);
    setModifiedFields(prev => new Set([...prev, field]));

    let error = null;
    if (!file) {
      
      error = `Image file is required for your ${field.charAt(0).toUpperCase() + field.slice(1)}`;
      
    } else {
        const fileName = file.name; // Get the name string from the File object
        const fileExt = fileName.split('.').pop().toLowerCase();

        // Check if extension is allowed
        if (['jpg', 'jpeg', 'png', 'gif'].includes(fileExt)) {
          // Valid extension
        } else {
          error = `Only jpg/jpeg/png and gif files are accepted for your ${field.charAt(0).toUpperCase() + field.slice(1)}`;
        }
    } 
        
        
      

   
    
    if (error) {
      setFormErrors(prev => ({...prev, [field]: error}));
    } else {
      setFormErrors(prev => {
        const newErrors = {...prev};
        delete newErrors[field];
        return newErrors;
      });
    }
  };
  
  return (
    <div className="form-section">
      <h4 className="text-lg font-medium text-gray-700 mb-3">Upload Photo Head Shot</h4>
      <div className="space-y-4">
      <div className="mb-4">
        <input
          id="photo-upload"
          type="file"
          name="photo"
          accept=".jpg, .jpeg, .png, .gif"
          className="hidden"
          onChange={(e) => validateImageFile('photo',e)}
          ref={photoInputRef}
        />
        
        {!formData.photo ? (
          <button
            type="button"
            onClick={() => photoInputRef.current.click()}
            className="upload-button flex items-center justify-center px-4 py-2 w-full bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-lg shadow hover:from-blue-600 hover:to-indigo-700 transition-all duration-200"
          >
            <span className="font-medium">Upload Photo Head Shot</span>
          </button>
        ) : (
          <div className="file-info p-3 bg-gray-50 rounded-md border border-gray-200">
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <span className="file-name text-sm font-medium text-gray-700">
                  {formData.photo.name}
                </span>
              </div>
              <button
                type="button"
                onClick={() => {
                  setFile('photo', null);
                  // Use the existing validation function with a mock empty event
                  validateImageFile('photo', { target: { files: [] } });
              }}
                className="text-sm text-red-600 hover:text-red-800 font-medium"
              >
                Remove
              </button>
            </div>
          </div>
        )}
        
        {formErrors.photo && modifiedFields && 
          typeof modifiedFields.has === 'function' && modifiedFields.has('photo') && (
          <div className="text-sm text-red-600 mt-1">
            {formErrors.photo}
          </div>
        )}
      </div>
    </div>
    </div>
  );
};

export default PhotoSection;